"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Time = styled_components_1.default.time `
	font-size: 0.8rem;
	color: ${props => props.theme.color.gray6};
	font-weight: normal;
	opacity: 0.75;
`;
